import { authInitialState } from 'core/auth/authInitialState';
import { createResourceReducer, concatReducers } from 'react-structure-admin';

import {
  LOGIN_REQUEST,
  LOGIN_REQUEST_FINISHED,
  LOGOUT,
  AUTH_REFRESH_USER,
  AUTH_REFRESH_TOKEN_FINISHED,
  AUTH_SUBSCRIPTION_CREATE_FINISHED,
  AUTH_SET_CURRENT_COLLABORATOR,
  AUTH_REMOVE_CURRENT_COLLABORATOR
} from './authActions';

const updateLocalStorage = (auth) => {
  localStorage.setItem('auth_data', btoa(JSON.stringify(auth)));
};

export const authReducer = createResourceReducer(
  'AUTH',
  { ...authInitialState },
  {
    [LOGIN_REQUEST](state, { payload }) {
      localStorage.removeItem('current_collaborator');

      return {
        ...state,
        authenticating: true
      };
    },

    [LOGIN_REQUEST_FINISHED](state, { payload }) {
      const now = new Date();
      now.setSeconds(now.getSeconds() + payload.data.expireInSeconds);

      return {
        ...state,
        ...payload.data,
        claims: payload.data.user.claims ?? [],
        expirationDate: now,
        authenticating: false,
        currentCollaborator: null
      };
    },

    [AUTH_REFRESH_TOKEN_FINISHED](state, { payload }) {
      const now = new Date();
      now.setSeconds(now.getSeconds() + payload.data.expireInSeconds);
      return {
        ...state,
        ...payload.data,
        expirationDate: now
      };
    },

    [LOGOUT](state) {
      localStorage.removeItem('current_collaborator');
      localStorage.removeItem('auth_refreshtoken');

      return {
        user: null,
        claims: [],
        permissions: [],
        expirationDate: null,
        tenantId: null,
        tenantName: null,
        company: null,
        subscription: null,
        refreshToken: null,
        accessToken: null,
        currentCollaborator: null
      };
    },

    [AUTH_REFRESH_USER](state, { payload }) {
      const auth = {
        ...state,
        user: {
          ...state.user,
          ...payload
        }
      };

      localStorage.setItem('auth_data', btoa(JSON.stringify(auth)));
      return auth;
    },

    [AUTH_SET_CURRENT_COLLABORATOR](state, { payload }) {
      return {
        ...state,
        currentCollaborator: payload
      };
    },

    [AUTH_REMOVE_CURRENT_COLLABORATOR](state) {
      return {
        ...state,
        currentCollaborator: null
      };
    }
  },
  (state) => ({
    ...state,
    authenticating: false
  })
);

export default concatReducers([authReducer], authInitialState);
